/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * What each gym role can do: Team's roles card and a staff invitation say the same words.
 */
export const ROLE_EXPLAINERS = [
  {
    role: "Owner",
    text: "Everything, including adding and removing admins. One per gym.",
  },
  {
    role: "Admin",
    text: "Everything the owner can, except adding or removing admins. Admins also coach.",
  },
  {
    role: "Coach",
    text: "Runs classes and checks members in. With “Can create programmes”, also writes gym and PT programmes.",
  },
];
